<template>
  <v-container fluid>
    <div class="s-summary" v-if="survey">
      <v-progress-circular class="global-progress" :size="40" :color="colors[colors.length - 1]" :value="node.etotalStuCount
        ? (((node.joinCount || 0) * 100) / node.etotalStuCount).toFixed(1)
        : 0
      ">{{
      node.etotalStuCount
        ? ((node.joinCount * 100) / node.etotalStuCount).toFixed(1)
        : 0
    }}%</v-progress-circular>
      <div class="text">
        有<em>{{ node.joinCount || 0 }}</em>人参与<br />共<em>{{ node.etotalStuCount || 0 }}</em>人
      </div>
      《{{ survey.name }}》结果统计
    </div>
    <div class="s-item" v-for="(item, idx) in items" :key="item.id">
      <v-divider />
      <p>{{ idx + 1 }}. {{ item.title }}</p>
      <template v-for="oidx of 6">
        <v-layout v-if="item['opt' + oidx]" :key="idx + '_o_' + oidx">
          <v-flex xs11 md10 class="s-opt-title">{{
      item["opt" + oidx]
    }}</v-flex>
          <v-flex xs1 md2>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-progress-linear v-on="on" :value="node.joinCount
        ? (
          ((logHash[item.id] || defaultVals)[oidx - 1] * 100) /
          node.joinCount
        ).toFixed(1)
        : 0
      " :color="colors[oidx]" />
              </template>
              <span>{{
      (logHash[item.id] || defaultVals)[oidx - 1] +
      "人(占比：" +
      (node.joinCount
        ? (
          ((logHash[item.id] || defaultVals)[oidx - 1] * 100) /
          node.joinCount
        ).toFixed(1)
        : 0) +
      "%)"
                }}</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </template>
    </div>
  </v-container>
</template>
<script>
export default {
  name: "survey-result",
  props: {
    node: Object,
    survey: Object,
    items: Array,
    logHash: Object,
  },
  data() {
    return {
      defaultVals: [0, 0, 0, 0, 0, 0],
      colors: this.$colors,
    };
  },
  watch: {},
};
</script>
<style scoped>
.s-summary {
  text-align: center;
  height: 50px;
  font-size: 16px;
}

.s-summary .global-progress {
  float: right;
  font-size: 12px;
}

.s-summary .text {
  float: left;
  text-align: left;
  font-size: 12px;
}

.s-summary .text em {
  color: hotpink;
}

.v-divider {
  margin: 8px 0;
}

.s-item {
  padding: 8px 0;
}

.s-item .s-opt-title {
  font-size: 12px;
  padding: 0 8px;
}
</style>